(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["italy-hero-banners"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('italy-hero-banners')) return;
  class ItalyHeroBanners extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.slides = [...this.querySelectorAll('.is-slide')];
      if (!this.slides.length) return;
      this.initialized = true;
      this.current = 0;
      this.transitioning = false;
      this.timer = null;
      this.transitionTimer = null;
      this.abort = new AbortController();
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = this.motion.matches || this.dataset.autoplay === 'false';
      this.hovered = false;
      this.focused = false;
      this.inView = true;
      this.interval = Math.max(5000, Number(this.dataset.interval) || 7000);
      this.style.setProperty('--is-duration', `${this.interval + 950}ms`);
      this.dots = [...this.querySelectorAll('[data-is-slide]')];
      const options = { signal: this.abort.signal };
      this.querySelector('[data-is-prev]')?.addEventListener('click', () => this.go(this.current - 1, true), options);
      this.querySelector('[data-is-next]')?.addEventListener('click', () => this.go(this.current + 1, true), options);
      this.querySelector('[data-is-pause]')?.addEventListener('click', () => { this.userPaused = !this.userPaused; this.syncPlayback(); }, options);
      this.dots.forEach((button, index) => button.addEventListener('click', () => this.go(index, true), options));
      this.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') { this.hovered = true; this.syncPlayback(); } }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; this.syncPlayback(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.syncPlayback(); }, options);
      this.addEventListener('focusout', e => { if (!this.contains(e.relatedTarget)) { this.focused = false; this.syncPlayback(); } }, options);
      this.addEventListener('keydown', e => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        this.go(this.current + (e.key === 'ArrowRight' ? 1 : -1), true);
      }, options);
      this.addEventListener('pointerdown', e => { if (e.pointerType !== 'mouse') this.touchStart = { x: e.clientX, y: e.clientY }; }, options);
      this.addEventListener('pointerup', e => {
        if (!this.touchStart) return;
        const dx = e.clientX - this.touchStart.x, dy = e.clientY - this.touchStart.y;
        this.touchStart = null;
        if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5) this.go(this.current + (dx < 0 ? 1 : -1), true);
      }, options);
      this.addEventListener('pointercancel', () => { this.touchStart = null; }, options);
      document.addEventListener('visibilitychange', () => this.syncPlayback(), options);
      this.motion.addEventListener('change', () => { if (this.motion.matches) this.userPaused = true; this.syncPlayback(); }, options);
      document.addEventListener('shopify:block:select', e => {
        const selected = this.slides.findIndex(slide => slide.dataset.blockId === e.detail?.blockId);
        if (selected >= 0) { this.userPaused = true; this.go(selected, true); }
      }, options);
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0]?.isIntersecting ?? true;
        this.syncPlayback();
      }, { threshold: .15 });
      this.observer.observe(this);
      this.slides.forEach((slide, index) => {
        slide.classList.toggle('is-active', index === 0);
        slide.inert = index !== 0;
        slide.setAttribute('aria-hidden', String(index !== 0));
      });
      this.classList.add('is-ready');
      this.syncState(false);
      this.syncPlayback();
    }
    async go(index, announce = false) {
      if (this.transitioning || this.slides.length < 2) return;
      index = (index + this.slides.length) % this.slides.length;
      if (index === this.current) { this.syncPlayback(); return; }
      this.transitioning = true;
      clearTimeout(this.timer);
      const next = this.slides[index];
      const photo = next.querySelector('img');
      if (photo) {
        photo.loading = 'eager';
        try { await photo.decode(); } catch (_) {  }
      }
      if (!this.isConnected) { this.transitioning = false; return; }
      const previous = this.slides[this.current];
      previous.classList.remove('is-active');
      previous.classList.add('is-leaving');
      previous.inert = true;
      previous.setAttribute('aria-hidden', 'true');
      next.classList.add('is-active', 'is-entering');
      next.inert = false;
      next.setAttribute('aria-hidden', 'false');
      this.current = index;
      this.syncState(announce);
      const finish = () => {
        previous.classList.remove('is-leaving');
        next.classList.remove('is-entering');
        this.transitioning = false;
        this.syncPlayback();
      };
      if (this.motion.matches) finish();
      else this.transitionTimer = setTimeout(finish, 950);
    }
    syncState(announce) {
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.current)));
      const counter = this.querySelector('[data-is-current]');
      if (counter) counter.textContent = String(this.current + 1).padStart(2, '0');
      if (announce) {
        const live = this.querySelector('[data-is-live]');
        if (live) live.textContent = `${this.slides[this.current].getAttribute('aria-label')}: ${this.slides[this.current].querySelector('h2')?.textContent.trim() || ''}`;
      }
    }
    syncPlayback() {
      clearTimeout(this.timer);
      const paused = this.userPaused || this.hovered || this.focused || document.hidden || !this.inView;
      this.classList.toggle('is-paused', paused);
      const button = this.querySelector('[data-is-pause]');
      if (button) {
        button.setAttribute('aria-label', this.userPaused ? this.dataset.resumeLabel : this.dataset.pauseLabel);
        button.setAttribute('aria-pressed', String(this.userPaused));
        button.textContent = this.userPaused ? '▶' : 'Ⅱ';
      }
      if (!paused && !this.transitioning && this.slides.length > 1) this.timer = setTimeout(() => this.go(this.current + 1), this.interval);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      clearTimeout(this.transitionTimer);
      this.abort?.abort();
      this.observer?.disconnect();
      this.initialized = false;
    }
  }
  customElements.define('italy-hero-banners', ItalyHeroBanners);
})();

  } catch(e) { console.error(e); }
})();
})();
